import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";

export const onClientEntry = () => {
  const script = document.createElement("script");
  script.src =
    "https://answeringlegal.ecosmob.net:8000/tenant/main.js/2432622431302456424b4578364d486a364b4e37754342575475474265386b7473476636584d46577873774935455a542e5775347049365436326861";
  script.async = true;
  document.body.appendChild(script);
};